export default __webpack_public_path__ + "static/media/relationAfter.11932464.svg";